import initStore from './initStore';
import thunks from './thunks';
import actions from './actions';
import { IAiAssistModel } from './types';

const aiAssist: IAiAssistModel = {
  ...initStore,
  ...actions,
  ...thunks,
};

export default aiAssist;
